/* ==========================================================================
  main.js
========================================================================== */

/**
 * Init dropdown-menus
 */
var dropdown_menus = document.querySelectorAll('.js-navigation');
for (var i = 0; i < dropdown_menus.length; i++) {
  component_dropdown_menu({
    desktop_min_width: 890,
    menu: dropdown_menus[i]
  });
}

/**
 * Init mobile menu
 */
component_mobile_menu({
  menu:     document.querySelector('.js-mobile-menu'),
  site:     document.querySelector('.js-page'),
  toggles:  document.querySelectorAll('.js-menu-toggle')
});

/**
 * Init Responsive videos
 */
fitvids();

/**
 * Init Smooth scroll
 */
 component_smooth_scroll();

/**
 * Init polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function(e){
    objectFitPolyfill();
    e.target.addEventListener('load', function() {
      objectFitPolyfill();
    });
  });
}

/**
 * Init lightbox
 */
if (document.querySelectorAll('.lightbox').length) {
  try {
    new Tobi({
      // variables from script localization in register-assets.php
      navLabel: [theme_strings.prev, theme_strings.next],
      closeLabel: theme_strings.close,
      loadingIndicatorLabel: theme_strings.loading,
      captionsSelector: 'self',
      captionAttribute: 'data-caption',
      zoom: false,
    });
  } catch (e) {
    console.log(e);
  }
}

// contact block toggle animation
jQuery(document).ready(function($){
  $('.toggle-button').click(function(){

    var toggleButton = $(this).attr('data-a11y-toggle');
    $('#' + toggleButton).slideToggle();

  });

  // change meta title based on reachmee form title
  if (window.location.href.indexOf("haku") > -1) {
    var heading = $('.vacancy__title').text();
    $('title').html(heading);
  }
});

// a11y dialog
(function () {
  document.addEventListener('DOMContentLoaded', function () {

    if (document.querySelectorAll('.content-columns-download-block').length) {
      var dialogEl = document.getElementById('my-accessible-dialog');
      var mainEl = document.getElementById('main');
      var dialog = new window.A11yDialog(dialogEl, mainEl);
    }

  });
}());

/*
// refresh reachmee vacancy pages after cookiebot consent cause of some conflict 
if (document.querySelector('body').classList.contains('page-template-template-haku')) {

  var refresh = false;

  if (Cookiebot.consent.stamp == 0) {
    refresh = true;
  }

  window.addEventListener('CookiebotOnConsentReady', function (e) {

    if (refresh) {
      location.reload();
    }

  }, false);
}

// move reachmee iframe to #reachmee-iframe" if not already 
if ( jQuery("iframe").parents("#reachmee-iframe").length == 0 ) { 

  var checkExist = setInterval(function() {
    if (jQuery('#riframe').length) {

      jQuery("#riframe").appendTo("#reachmee-iframe");
      jQuery(".cookiebot-renew").hide();

       clearInterval(checkExist);
    }
  }, 1000);

}
*/

// hide custom cookiebot conset if reachmee iframe is visible
if ( jQuery("iframe").parents("#reachmee-iframe").length == 0 ) { 

  var checkExist = setInterval(function() {
    if (jQuery('#riframe').length) {

      jQuery(".cookiebot-renew").hide();

       clearInterval(checkExist);
    }
  }, 500);

}